import React from 'react'

class ViewLocality extends React.Component {
  render() {
    return <div>fefe</div>
  }
}

export default ViewLocality
